export default __webpack_public_path__ + "static/media/HornsFailSound.c47b39a9.mp3";